/* eslint-disable react/prop-types */
import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const dictionary = {
    es: {
        education: {
            heroEyebrow: "NIDA Digital / Educación",
            heroTitle1: "Tu colegio, conectado.",
            heroTitle2: "Seguro. Preparado.",
            heroDesc: "Diseñamos, modernizamos y mantenemos la tecnología que hace funcionar tu centro educativo. Un único partner para toda tu infraestructura digital.",
            cta: "Solicitar asesoramiento",
            discover: "Descubrir soluciones",
            challengeEyebrow: "Entendemos tu centro",
            challengeTitle: "La tecnología debe facilitar la enseñanza, no complicarla.",
            challengeDesc1: "Una conexión inestable, una red saturada o un sistema desactualizado afectan al funcionamiento diario.",
            challengeDesc2: "Ayudamos a los centros educativos a construir infraestructuras fiables, seguras y fáciles de gestionar.",
            solutionsEyebrow: "Soluciones para Educación",
            solutionsTitle1: "Todo tu ecosistema tecnológico.",
            solutionsTitle2: "Un solo partner.",
            projectsEyebrow: "Áreas de especialización",
            projectsTitle: "Infraestructuras que transforman centros.",
            projectsDesc: "Tres ámbitos especialmente relevantes en la modernización tecnológica de instalaciones educativas.",
            methodEyebrow: "Nuestra metodología",
            methodTitle: "De la evaluación inicial al soporte continuo.",
            contactEyebrow: "Hablemos de tu centro",
            contactTitle: "¿Preparamos tu colegio para el futuro?",
            contactDesc: "Cuéntanos qué necesitas mejorar y estudiaremos cómo ayudarte a modernizar tu infraestructura tecnológica.",
            solution1Title: "Redes de alta velocidad",
            solution1Desc: "Diseñamos y modernizamos infraestructuras de red para conectar aulas, departamentos y servicios del centro con fiabilidad.",
            solution2Title: "WiFi unificado y balanceado",
            solution2Desc: "Cobertura inalámbrica gestionada de forma centralizada, con segmentación, control de usuarios y distribución eficiente de conexiones.",
            solution3Title: "Control de accesos",
            solution3Desc: "Soluciones para gestionar y supervisar los accesos a instalaciones y espacios autorizados.",
            solution4Title: "Ciberseguridad",
            solution4Desc: "Protección de redes, dispositivos e información mediante medidas adaptadas a las necesidades de los centros educativos.",
            solution5Title: "Aulas digitales",
            solution5Desc: "Equipamiento, conectividad e integración tecnológica para facilitar la enseñanza y el trabajo diario.",
            solution6Title: "Telefonía y comunicaciones",
            solution6Desc: "Comunicaciones integradas para mejorar la coordinación entre administración, profesorado y equipos de gestión.",
            solution7Title: "Cloud y sistemas",
            solution7Desc: "Servicios e infraestructura para gestionar recursos digitales, almacenamiento y herramientas de colaboración.",
            solution8Title: "Mantenimiento y soporte",
            solution8Desc: "Acompañamiento técnico para mantener la infraestructura operativa y resolver incidencias.",
            project1Title: "Infraestructura de redes y WiFi profesional",
            project1Desc: "Diseñamos y modernizamos redes de alta velocidad y soluciones WiFi centralizadas para ofrecer conectividad fiable y adaptada a las necesidades del centro.",
            project2Title: "Ciberseguridad para centros educativos",
            project2Desc: "Protegemos redes, dispositivos y sistemas frente a amenazas digitales mediante soluciones de seguridad adaptadas a los entornos educativos.",
            project3Title: "Control de accesos y videovigilancia",
            project3Desc: "Implantamos soluciones de acceso mediante tarjeta para aulas y edificios, junto con sistemas de videovigilancia para mejorar la seguridad de las instalaciones.",
            method1Title: "Analizamos",
            method1Desc: "Estudiamos las necesidades y la infraestructura existente.",
            method2Title: "Diseñamos",
            method2Desc: "Proponemos soluciones adaptadas al centro y sus prioridades.",
            method3Title: "Implementamos",
            method3Desc: "Coordinamos la instalación, configuración y puesta en marcha.",
            method4Title: "Acompañamos",
            method4Desc: "Ofrecemos mantenimiento, soporte y evolución tecnológica.",
        },
        nav: {
            services: "Servicios",
            sectors: "Sectores",
            education: "Educación",
            industrySoon: "Industria · Próximamente",
            value: "Por qué Nida",
            cases: "Casos",
            process: "Proceso",
            trust: "Confianza",
            contact: "Contacto",
            cta: "Asesoría gratuita",
            admin: "Admin",
        },
        hero: {
            eyebrow: "Partner tecnológico integral",
            title1: "Soluciones",
            title2: "Digitales 360",
            title3: "para empresas que quieren crecer",
            subtitle:
                "Desarrollo, IT, ciberseguridad, inteligencia artificial y transformación digital en un solo proveedor.",
            cta1: "Solicitar asesoría gratuita",
            cta2: "Ver servicios",
            badge1: "ISO 27001 · ENS · NIS2",
            badge2: "+15 años en el grupo Laredo Agenjo",
        },
        services: {
            eyebrow: "Servicios 360",
            title: "Un solo partner.\nTodo el ecosistema digital.",
            subtitle:
                "Agrupamos las disciplinas que tu empresa necesita en un único equipo de especialistas. Sin proveedores fragmentados.",
            cta: "Saber más",
            cats: [
                {
                    key: "dev",
                    title: "Desarrollo Digital",
                    desc: "Webs, apps a medida y plataformas e-commerce escalables.",
                    items: ["Páginas web", "Aplicaciones a medida", "E-commerce"],
                },
                {
                    key: "it",
                    title: "IT & Infraestructura",
                    desc: "La columna vertebral tecnológica de tu negocio, sin interrupciones.",
                    items: ["Redes", "Cloud", "Soporte técnico", "Renting de equipos"],
                },
                {
                    key: "sec",
                    title: "Ciberseguridad & Compliance",
                    desc: "Cumplimiento normativo y protección avanzada frente a amenazas reales.",
                    items: ["NIS2 · ENS · ISO 27001 · RGPD", "Auditorías", "Protección avanzada"],
                },
                {
                    key: "ai",
                    title: "Inteligencia Artificial",
                    desc: "Automatización e IA aplicada para escalar procesos y decisiones.",
                    items: ["Automatización", "IA para negocio", "Integraciones"],
                },
                {
                    key: "mkt",
                    title: "Marketing & Branding",
                    desc: "Identidad, contenido y estrategia digital para crecer con foco.",
                    items: ["Identidad corporativa", "Redes sociales", "Estrategia digital", "Merchandising"],
                },
                {
                    key: "iot",
                    title: "Domótica & Espacios Inteligentes",
                    desc: "Hogar y oficina automatizados con instalación y mantenimiento.",
                    items: ["Hogar y oficina", "Instalación y mantenimiento"],
                },
                {
                    key: "doc",
                    title: "Gestión Documental",
                    desc: "Del papel a la nube con trazabilidad completa.",
                    items: ["Digitalización", "Almacenamiento físico y cloud", "Destrucción segura"],
                },
            ],
        },
        value: {
            eyebrow: "Por qué Nida Digital",
            title: "Cinco razones para\nelegir un partner integral.",
            pillars: [
                { title: "Servicio integral 360", desc: "Estrategia, ejecución y mantenimiento bajo el mismo techo." },
                { title: "Un solo proveedor", desc: "Menos coordinación, más responsabilidad y resultados." },
                { title: "Soporte continuo", desc: "Equipo accesible y SLAs reales para tu operativa diaria." },
                { title: "Adaptación normativa", desc: "NIS2, ENS, ISO 27001 y RGPD aplicados a tu día a día." },
                { title: "Tecnología avanzada accesible", desc: "Cloud, IA y ciber al alcance de empresas reales." },
            ],
        },
        cases: {
            eyebrow: "Casos de uso",
            title: "Lo que resolvemos\npor ti.",
            items: [
                {
                    title: "Digitalizamos tu empresa desde cero",
                    desc: "Diseñamos un plan de transformación end-to-end: web, ERP, procesos y formación de equipos.",
                    bullets: ["Auditoría inicial", "Roadmap por fases", "Formación interna"],
                },
                {
                    title: "Modernizamos tu infraestructura IT",
                    desc: "Migramos a cloud, securizamos redes y dejamos tu operativa lista para escalar.",
                    bullets: ["Cloud & redes", "Renting de equipos", "Soporte 24/7"],
                },
                {
                    title: "Protegemos tu negocio ante ciberataques",
                    desc: "Detección, respuesta y compliance NIS2/ENS/ISO 27001 con monitorización continua.",
                    bullets: ["Auditorías", "Hardening", "Plan de respuesta"],
                },
                {
                    title: "Automatizamos procesos con IA",
                    desc: "Identificamos cuellos de botella y los automatizamos con IA y herramientas integradas.",
                    bullets: ["Mapeo de procesos", "Pilotos rápidos", "Integraciones a medida"],
                },
            ],
        },
        process: {
            eyebrow: "Proceso",
            title: "Cómo trabajamos contigo",
            steps: [
                { n: "01", title: "Análisis", desc: "Entendemos tu operación, riesgos y objetivos en profundidad." },
                { n: "02", title: "Planificación", desc: "Diseñamos un roadmap claro con hitos y métricas accionables." },
                { n: "03", title: "Implementación", desc: "Ejecutamos con un equipo único y comunicación cercana." },
                { n: "04", title: "Mantenimiento", desc: "Soporte y mejora continua para que nada se detenga." },
            ],
        },
        trust: {
            eyebrow: "Confianza",
            title: "Cumplimiento, certificaciones y clientes.",
            certs: ["NIS2", "ISO 27001", "ENS", "RGPD", "ISO 9001", "ENISA"],
            testimonialsTitle: "Lo que dicen las empresas con las que trabajamos",
        },
        finalCta: {
            eyebrow: "Da el siguiente paso",
            title: "Impulsa tu negocio con tecnología.",
            subtitle: "Cuéntanos tu reto y te respondemos con un plan en 48 horas.",
        },
        contact: {
            title: "Habla con nosotros",
            subtitle: "Te respondemos en menos de 48 horas laborables.",
            name: "Nombre",
            email: "Email corporativo",
            phone: "Teléfono",
            company: "Empresa",
            service: "Servicio de interés",
            servicePlaceholder: "Selecciona una categoría",
            message: "Cuéntanos tu reto",
            send: "Enviar mensaje",
            sending: "Enviando…",
            success: "¡Gracias! Hemos recibido tu mensaje.",
            error: "No hemos podido enviar tu mensaje. Inténtalo de nuevo.",
            consent: "Acepto la política de privacidad",
        },
        footer: {
            tagline: "Partner tecnológico integral del grupo Laredo Agenjo.",
            services: "Servicios",
            company: "Compañía",
            legal: "Legal",
            contact: "Contacto",
            copyright: "© {year} Nida Digital · Anpada XXI · Grupo Laredo Agenjo. Todos los derechos reservados.",
            links: {
                privacy: "Privacidad",
                terms: "Términos",
                cookies: "Cookies",
                about: "Sobre nosotros",
                careers: "Trabaja con nosotros",
                blog: "Blog",
            },
        },
        admin: {
            login: "Acceder al panel",
            password: "Contraseña",
            signIn: "Entrar",
            wrong: "Contraseña incorrecta",
            title: "Panel CRM · Leads",
            subtitle: "Gestiona los contactos recibidos desde la web",
            logout: "Cerrar sesión",
            empty: "Aún no hay leads. ¡Comparte la web!",
            statuses: { new: "Nuevo", contacted: "Contactado", qualified: "Cualificado", won: "Ganado", lost: "Perdido" },
        },
    },
    en: {
        education: {
            heroEyebrow: "NIDA Digital / Education",
            heroTitle1: "Your school, connected.",
            heroTitle2: "Secure. Future-ready.",
            heroDesc: "We design, modernize and maintain the technology that keeps your educational institution running. One technology partner for your entire digital infrastructure.",
            cta: "Request a consultation",
            discover: "Explore solutions",
            challengeEyebrow: "We understand your school",
            challengeTitle: "Technology should make teaching easier, not more complicated.",
            challengeDesc1: "Unreliable connectivity, overloaded networks and outdated systems can disrupt daily operations.",
            challengeDesc2: "We help educational institutions build reliable, secure and easy-to-manage infrastructure.",
            solutionsEyebrow: "Solutions for Education",
            solutionsTitle1: "Your entire technology ecosystem.",
            solutionsTitle2: "One partner.",
            projectsEyebrow: "Areas of expertise",
            projectsTitle: "Infrastructure that transforms schools.",
            projectsDesc: "Three key areas in the technological modernization of educational facilities.",
            methodEyebrow: "Our approach",
            methodTitle: "From initial assessment to ongoing support.",
            contactEyebrow: "Let's talk about your school",
            contactTitle: "Ready to prepare your school for the future?",
            contactDesc: "Tell us what you need to improve and we'll explore how to modernize your technology infrastructure.",
            solution1Title: "High-speed networks",
            solution1Desc: "We design and modernize network infrastructure to reliably connect classrooms, departments and school services.",
            solution2Title: "Unified and load-balanced WiFi",
            solution2Desc: "Centrally managed wireless coverage with network segmentation, user control and efficient connection distribution.",
            solution3Title: "Access control",
            solution3Desc: "Solutions to manage and monitor access to facilities and authorized areas.",
            solution4Title: "Cybersecurity",
            solution4Desc: "Protection for networks, devices and information with measures tailored to educational institutions.",
            solution5Title: "Digital classrooms",
            solution5Desc: "Equipment, connectivity and technology integration to support teaching and daily activities.",
            solution6Title: "Telephony and communications",
            solution6Desc: "Integrated communications to improve coordination between administration, teachers and management teams.",
            solution7Title: "Cloud and systems",
            solution7Desc: "Services and infrastructure to manage digital resources, storage and collaboration tools.",
            solution8Title: "Maintenance and support",
            solution8Desc: "Technical assistance to keep infrastructure operational and resolve incidents.",
            project1Title: "Professional networking and WiFi infrastructure",
            project1Desc: "We design and modernize high-speed networks and centrally managed WiFi solutions to provide reliable connectivity tailored to each school's needs.",
            project2Title: "Cybersecurity for educational institutions",
            project2Desc: "We protect networks, devices and systems against digital threats with security solutions tailored to educational environments.",
            project3Title: "Access control and video surveillance",
            project3Desc: "We implement card-based access solutions for classrooms and buildings, alongside video surveillance systems to improve facility security.",
            method1Title: "Assess",
            method1Desc: "We review your needs and existing infrastructure.",
            method2Title: "Design",
            method2Desc: "We propose solutions tailored to your institution and priorities.",
            method3Title: "Implement",
            method3Desc: "We coordinate installation, configuration and commissioning.",
            method4Title: "Support",
            method4Desc: "We provide maintenance, support and ongoing technology improvements.",
        },
        nav: {
            services: "Services",
            sectors: "Sectors",
            education: "Education",
            industrySoon: "Industry · Coming soon",
            value: "Why Nida",
            cases: "Use cases",
            process: "Process",
            trust: "Trust",
            contact: "Contact",
            cta: "Free consultation",
            admin: "Admin",
        },
        hero: {
            eyebrow: "End-to-end technology partner",
            title1: "360° Digital",
            title2: "Solutions",
            title3: "for companies that want to grow",
            subtitle:
                "Development, IT, cybersecurity, AI and digital transformation under a single provider.",
            cta1: "Request a free consultation",
            cta2: "Explore services",
            badge1: "ISO 27001 · ENS · NIS2",
            badge2: "+15 years in the Laredo Agenjo group",
        },
        services: {
            eyebrow: "360° Services",
            title: "One partner.\nThe whole digital stack.",
            subtitle:
                "We bring together every discipline your company needs into a single specialist team. No fragmented vendors.",
            cta: "Learn more",
            cats: [
                { key: "dev", title: "Digital Development", desc: "Websites, custom apps and scalable e-commerce.", items: ["Websites", "Custom apps", "E-commerce"] },
                { key: "it", title: "IT & Infrastructure", desc: "The technological backbone of your business, with zero downtime.", items: ["Networks", "Cloud", "Tech support", "Equipment leasing"] },
                { key: "sec", title: "Cybersecurity & Compliance", desc: "Regulatory compliance and advanced protection against real threats.", items: ["NIS2 · ENS · ISO 27001 · GDPR", "Audits", "Advanced protection"] },
                { key: "ai", title: "Artificial Intelligence", desc: "Automation and applied AI to scale processes and decisions.", items: ["Automation", "AI for business", "Integrations"] },
                { key: "mkt", title: "Marketing & Branding", desc: "Identity, content and digital strategy to grow with focus.", items: ["Corporate identity", "Social media", "Digital strategy", "Merchandising"] },
                { key: "iot", title: "Smart Spaces & IoT", desc: "Automated home and office with installation and maintenance.", items: ["Home and office", "Install & maintenance"] },
                { key: "doc", title: "Document Management", desc: "From paper to cloud with full traceability.", items: ["Digitization", "Physical & cloud storage", "Secure destruction"] },
            ],
        },
        value: {
            eyebrow: "Why Nida Digital",
            title: "Five reasons to choose\nan integral partner.",
            pillars: [
                { title: "Full 360° service", desc: "Strategy, execution and maintenance under one roof." },
                { title: "Single provider", desc: "Less coordination, more accountability and results." },
                { title: "Continuous support", desc: "Accessible team and real SLAs for your daily operations." },
                { title: "Regulatory alignment", desc: "NIS2, ENS, ISO 27001 and GDPR applied day to day." },
                { title: "Accessible advanced tech", desc: "Cloud, AI and cyber within reach of real companies." },
            ],
        },
        cases: {
            eyebrow: "Use cases",
            title: "What we solve\nfor you.",
            items: [
                { title: "We digitize your company from scratch", desc: "End-to-end transformation plan: web, ERP, processes and team training.", bullets: ["Initial audit", "Phased roadmap", "Team training"] },
                { title: "We modernize your IT infrastructure", desc: "We migrate to cloud, secure networks and prepare your operations to scale.", bullets: ["Cloud & networks", "Equipment leasing", "24/7 support"] },
                { title: "We protect your business from cyberattacks", desc: "Detection, response and NIS2/ENS/ISO 27001 compliance with continuous monitoring.", bullets: ["Audits", "Hardening", "Response plan"] },
                { title: "We automate processes with AI", desc: "We identify bottlenecks and automate them with AI and integrated tools.", bullets: ["Process mapping", "Quick pilots", "Custom integrations"] },
            ],
        },
        process: {
            eyebrow: "Process",
            title: "How we work with you",
            steps: [
                { n: "01", title: "Analysis", desc: "We understand your operation, risks and goals in depth." },
                { n: "02", title: "Planning", desc: "We design a clear roadmap with milestones and metrics." },
                { n: "03", title: "Implementation", desc: "We execute with a single team and close communication." },
                { n: "04", title: "Maintenance", desc: "Support and continuous improvement so nothing stops." },
            ],
        },
        trust: {
            eyebrow: "Trust",
            title: "Compliance, certifications and clients.",
            certs: ["NIS2", "ISO 27001", "ENS", "GDPR", "ISO 9001", "ENISA"],
            testimonialsTitle: "What our clients say",
        },
        finalCta: {
            eyebrow: "Take the next step",
            title: "Power your business with technology.",
            subtitle: "Tell us your challenge and we'll come back with a plan in 48 hours.",
        },
        contact: {
            title: "Talk to us",
            subtitle: "We reply within 48 business hours.",
            name: "Name",
            email: "Work email",
            phone: "Phone",
            company: "Company",
            service: "Service of interest",
            servicePlaceholder: "Pick a category",
            message: "Tell us about your challenge",
            send: "Send message",
            sending: "Sending…",
            success: "Thanks! We've received your message.",
            error: "We couldn't send your message. Please try again.",
            consent: "I accept the privacy policy",
        },
        footer: {
            tagline: "End-to-end technology partner from the Laredo Agenjo group.",
            services: "Services",
            company: "Company",
            legal: "Legal",
            contact: "Contact",
            copyright: "© {year} Nida Digital · Anpada XXI · Laredo Agenjo Group. All rights reserved.",
            links: { privacy: "Privacy", terms: "Terms", cookies: "Cookies", about: "About", careers: "Careers", blog: "Blog" },
        },
        admin: {
            login: "Sign in to dashboard",
            password: "Password",
            signIn: "Sign in",
            wrong: "Wrong password",
            title: "CRM · Leads",
            subtitle: "Manage contacts received from the website",
            logout: "Sign out",
            empty: "No leads yet. Share the website!",
            statuses: { new: "New", contacted: "Contacted", qualified: "Qualified", won: "Won", lost: "Lost" },
        },
    },
};

const I18nContext = createContext({ lang: "es", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("nida_lang") || "es");

    useEffect(() => {
        localStorage.setItem("nida_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const value = useMemo(() => {
        const get = (path) => {
            const parts = path.split(".");
            let cur = dictionary[lang];
            for (const p of parts) {
                cur = cur?.[p];
                if (cur === undefined) return path;
            }
            return cur;
        };
        return { lang, setLang, t: get, dict: dictionary[lang] };
    }, [lang]);

    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
